import { render, staticRenderFns } from "./NavBarBreadcrumb.vue?vue&type=template&id=38e43808&scoped=true"
import script from "./NavBarBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavBarBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavBarBreadcrumb.vue?vue&type=style&index=0&id=38e43808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e43808",
  null
  
)

export default component.exports